import { EnvironmentService } from './../../../core/enviroment/environment.service';
import { Column } from './../../table-models';
import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

interface Contact {
  email: string;
  cellphone: string;
}

interface LeadByBroker {
  client: string;
  company: string;
  avatar: string;
  broker: string;
  product: string;
  contact?: Contact;
}

export interface Lead {
  name: string;
  distributed: number;
  attended: number;
  notAttended: number;
  avatar: string;
  lista: LeadByBroker[];
}

export interface Tag {
  id: number;
  value: string;
}

@Component({
  selector: 'app-impounded-leads',
  templateUrl: './impounded-leads.component.html',
  styleUrls: ['./impounded-leads.component.scss', '../../table_leads.scss']
})
export class ImpoundedLeadsComponent implements OnInit {
  @Input() propsFilter = [];
  public showFilter: boolean;
  public hasFilter: boolean;
  public isSelect: boolean;
  public showImpoundedFilter = false;
  public modal2: boolean;
  public titleLeadsModal: string;
  public textFieldSearch = '';
  public options = [];
  public dataSelected = [];
  public rowDown = false;
  public tags: Tag[] = [
    { value: 'Fila: Produtos da Região Central de SP', id: 0 },
    { value: 'Empresa: Lopes SP', id: 1 },
    { value: 'Equipe: Martins', id: 2 },
    { value: 'Fila: Produtos da Região Central de SP', id: 3 },
    { value: 'Fila: Produtos da Região Central de SP', id: 4 },
  ];
  public data = [
    {
      isChecked: false,
      client: 'Niels Henrique David Bohr',
      company: 'Lopes São Paulo',
      level: 'Martins',
      broker: 'João (Martins)',
      product: 'Plano e parque do carmo - Iososuke I',
      queue: 'Produtos da Região Central de SP',
      inclusionDate: '05/05/2020 23:45',
      contact: {
        email: 'niels.henrique@gmail.com', cellphone: '(67) 67 98947 - 2324',
      }
    },
    {
      isChecked: false,
      client: 'Niels Henrique',
      company: 'Lopes Jardim',
      level: 'Martins',
      broker: 'João (Martins)',
      product: 'Plano e São Luiz - Iososuke I',
      queue: 'Produtos da Região de SP',
      inclusionDate: '05/05/2020 23:45',
      contact: {
        email: 'niels.henrique@gmail.com', cellphone: '(67) 67 98947 - 2324',
      }
    }
  ];
  public showDot: boolean;
  public form: FormGroup;
  public facId: string;
  public showFacModal: boolean;
  public headers: Column[] = [
    { label: '', id: 'isChecked', hasCheckbox: true, style: { width: '20px' }, isSelect: false },
    { label: 'Cliente', id: 'client', sort: true, style: { width: '200px' } },
    { label: 'Empresa', id: 'company', sort: true, style: { width: '150px' }, onClick: (lead) => this.handleOpenLeads(lead) },
    { label: 'Nível', id: 'level', sort: true, style: { width: '100px' }, onClick: (lead) => this.handleOpenLeads(lead) },
    { label: 'Fila', id: 'queue', sort: true, style: { width: '230px' }, onClick: (lead) => this.handleOpenLeads(lead) },
    { label: 'Produto', id: 'product', sort: true, style: { width: '250px' }, onClick: (lead) => this.handleOpenLeads(lead) },
    { label: 'Contato', id: 'contact', contact: true, style: { width: '130px' }, onClick: (lead) => this.handleOpenLeads(lead) },
    { label: 'Data de inclusão', id: 'inclusionDate', sort: true, style: { width: '130px' }, onClick: (lead) => this.handleOpenLeads(lead) }
  ];
  public listBinding = [];
  public featureInputSearch = false

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.rowDown) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.rowDown = false;
      }
    }
  }

  constructor(
    private fb: FormBuilder,
    private eRef: ElementRef,
    private environmentService: EnvironmentService
  ) { }

  ngOnInit(): void {
    this.featureInputSearch = this.environmentService.getEnvVar('feature_input_search') === 'true';  
    this.form = this.fb.group({
      createTime: [null],
      distributionTime: [null],
      distributionPending: [null]
    });
    this.modal2 = false;
    this.showFilter = false;
    this.hasFilter = false;
  }

  public clear() {
    this.hasFilter = false;
    this.form = this.fb.group({
      createTime: [null],
      distributionTime: [null],
      distributionPending: [null]
    });
  }

  public selectAction(option: number): void {
    this.rowDown = false;
    if (option === 1) {
      this.showImpoundedFilter = true;
    }
  }

  public openFacModal() {
    // TODO: remove hard coded facID
    this.facId = '01278d63-0000-0000-0000-000000000000';
    this.showFacModal = true;
  }

  public closeImpoundedFilter() {
    this.showImpoundedFilter = false;
  }

  public closeFacModal() {
    this.facId = null;
    this.showFacModal = false;
  }

  public applyFilter() {
    if (this.validator()) {
      this.hasFilter = true;
    }
    this.showFilter = false;
  }

  public closeLeadsByBroker() {
    this.modal2 = !this.modal2;
    this.titleLeadsModal = null;
    this.dataSelected = [];
  }

  public handleModal() {
    this.showFilter = !this.showFilter;
  }

  public handleOpenLeads(lead: Lead): void {
    this.titleLeadsModal = lead.name;
    this.dataSelected = lead.lista;
    this.modal2 = !this.modal2;
  }


  public onSelect() {
    this.isSelect = !this.isSelect;
    this.isSelect = this.data.every((item: any) => item.isChecked);
  }

  public selectAll() {
    this.isSelect ? this.data.forEach(x => x.isChecked = true) : this.data.forEach(x => x.isChecked = false);
    this.data = this.isSelect ? this.data.map(x => ({ ...x, isChecked: true })) : this.data.map(x => ({ ...x, isChecked: false }));
  }

  public hasBtnAction() {
    return this.data.some((item: any) => item.isChecked);
  }

  public validator(): boolean {
    return Object.keys(this.form.controls).some(key => !!this.form.get(key).value);
  }

  public disableInput(event) {
  }

  public searchElement(value) {
    this.options = [{ description: 'Niels Henquique David Bohr', type: 'Cliente' }, { description: 'Niels Henrique', type: 'Cliente' }];
  }

  public elementSelected(event) {
  }

  public closedSearch() { }
  public searchInput(data) { }
  public removeTag(tag: Tag): void {
    this.tags.splice(tag.id, 1);
  }

  public sort(event: MouseEvent, column: Column) {
    // TODO: sort by column
  }
}
